import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HotRankingSection() {
  const hotList = [...articles].sort((a, b) => b.views - a.views).slice(0, 8);

  const medalColors = ['text-accent-500', 'text-foreground-400', 'text-secondary-500'];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10">
          <div className="lg:w-2/3">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-10 h-10 flex items-center justify-center bg-accent-500 rounded-lg">
                <i className="ri-fire-line text-background-50 text-xl"></i>
              </div>
              <div>
                <h2 className="font-heading text-2xl text-foreground-950">热门排行</h2>
                <p className="text-xs text-foreground-500">阅读量最高的火影同人作品</p>
              </div>
            </div>

            <div className="flex flex-col gap-2">
              {hotList.map((article, index) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group flex items-center gap-4 p-3 rounded-lg hover:bg-background-50 transition-colors cursor-pointer"
                >
                  <div className="flex-shrink-0 w-8 text-center">
                    {index < 3 ? (
                      <i className={`ri-medal-line text-xl ${medalColors[index]}`}></i>
                    ) : (
                      <span className="text-sm font-bold text-foreground-400">{index + 1}</span>
                    )}
                  </div>
                  <div className="flex-shrink-0 w-14 h-10 rounded-md overflow-hidden">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <div className="flex items-center gap-3 text-xs text-foreground-400 mt-1">
                      <span>{article.category}</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:w-1/3">
            <div className="bg-background-50 rounded-xl p-6 border border-background-200">
              <div className="flex items-center gap-2 mb-4">
                <i className="ri-trophy-line text-primary-500 text-xl"></i>
                <h3 className="font-heading text-lg text-foreground-950">投稿指南</h3>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                想要分享你的火影同人创作？我们欢迎所有形式的原创同人作品投稿！
              </p>
              <ul className="flex flex-col gap-3 mb-5">
                <li className="flex items-start gap-2 text-sm text-foreground-600">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5"></i>
                  <span>支持漫画、小说、画集等多种形式</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-foreground-600">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5"></i>
                  <span>编辑团队7个工作日内审核回复</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-foreground-600">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5"></i>
                  <span>通过审核即获首页推荐曝光</span>
                </li>
              </ul>
              <Link
                to="/about#contact"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line"></i>
                立即投稿
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}